import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { PromotionService, CntryBannerItemModel, PagerService, AlertService, TableHeader, CommonService } from '../../../services/index'
import { Util } from '../../../utils'
import _ from 'lodash';

declare var $:any;

@Component({
  selector: 'account-list',
  templateUrl: 'account-list.html'
})
export class AccountListComponent {
  getAccountListSub:Subscription;

  accountList: Array<CntryBannerItemModel> = [];
  tempAccountList = new Array();
  headerList:Array<TableHeader> = null;
  
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();

  selectedAccount: CntryBannerItemModel;

  isEditing: boolean = false;

  accountCountries: Array<string> = [];

  numberWithCommas:Function = Util.numberWithCommas;

  constructor(
    private promotionService : PromotionService,
    private pagerService: PagerService, 
    private alertService:AlertService,
    private commonService: CommonService,
  ) {
    this.makeHeader();
    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempAccountList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  } 

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'cntryBannerItemId', 'No.', true));
    this.headerList.push(new TableHeader(1, 'countryName', '국가', true));
    this.headerList.push(new TableHeader(2, 'tier', 'Tier', true));
    this.headerList.push(new TableHeader(3, 'max', '최대판매 가능수량', true));
    this.headerList.push(new TableHeader(4, 'price', '구좌당 가격', true));
    this.headerList.push(new TableHeader(5, 'sellCnt', '계약 중 수량', true));
    this.headerList.push(new TableHeader(6, '', '수정', false));
  }
  

  ngOnInit() {
    this.search(1);
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch(1);
  }

  search(page){
    this.getAccountListSub = this.promotionService.getAccountList().subscribe((res:any)=>{
      this.accountList = res.data;
      this.tempAccountList = this.accountList;
      if(this.searchOption.conditionText && this.searchOption.conditionText.length > 0){
        this.conditionSearch(page);
      } else {
        this.setPage(page);
      }; 

      for(let account of this.accountList) {
        this.accountCountries.push(account.countryCode);
      };

      this.accountCountries.push('KR');
    });
  }
  

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempAccountList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempAccountList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  conditionSearch(page){
    if(_.isEmpty(this.accountList)) return;

    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    this.tempAccountList = _.map(_.filter(this.accountList,
      (account:CntryBannerItemModel) => {
        if(!keyword) return true;
        else if (_.upperCase(account.countryName).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(account.countryCode).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(account.tier).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(account.max).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(account.price).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(account.sellCnt).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.setPage(page);
    this.commonService.clearOrderByHeader(this.headerList);
  }

  addNewAccount() {
    this.selectedAccount = new CntryBannerItemModel();
    this.isEditing = false;
    $('body').css('overflow', 'hidden');
  }

  editAccount(account) {
    this.selectedAccount = _.cloneDeep(account);
    this.isEditing = true;
    $('body').css('overflow', 'hidden');
  }

  hideAccountDetail() {
    this.selectedAccount = null;
    this.isEditing = false;
    $('body').css('overflow', 'visible'); 
  }

  ngOnDestroy() {
    if(this.getAccountListSub) this.getAccountListSub.unsubscribe();
  }

  refresh(){
    this.search(1);
  }

}

class SearchOption {
  conditionText:string;
}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/account/account-list.ts